import { DataBean } from "../../DataBean";


export class NationalizationPhoto extends DataBean {

    public async getNationalizationPhotoCatalogPorPropiedades(properties: Record<string, any>, maxRows: number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getNationalizationPhotoCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }

    public async deleteNationalizationPhoto(idnationalizationphoto: number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "boolean_deleteNationalizationPhoto_Number", [idnationalizationphoto]);
    }

    public async updateNationalizationPhoto(bean: any): Promise<any> {
        return this.getCustomService(
            "ProcessContractERP",
            "com.orange.finance.processcontract.bean.NationalizationPhoto_updateNationalizationPhoto_com.orange.finance.processcontract.bean.NationalizationPhoto",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.orange.finance.processcontract.bean.NationalizationPhoto"
                }
            ]
        );
    }

}